module.exports = __webpack_public_path__ + "res/roboto-v15-latin-regular.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-regular.woff
// module id = 107
// module chunks = 1